import anime from 'animejs';
import { mqMediumLargeNav } from '../../js/utils/matchMedia';

const header = () => {
  const staticHeader = document.querySelector('.v-header');
  const stickyHeader = document.querySelector('.v-header-sticky');
  const staticHeaderSearchBtn = staticHeader.querySelector('.v-nav__search-trigger');
  const stickyHeaderSearchBtn = stickyHeader.querySelector('.v-nav-sticky__search-trigger');
  const hamburger = document.querySelector('.v-header__nav-trigger');
  const hamburgerSticky = document.querySelector('.v-header-sticky__nav-trigger');
  const menuOverlay = document.querySelector('.v-header-overlay');
  const menuNav = staticHeader.querySelector('.v-header__nav');
  const menuSearchField = menuNav.querySelector('.v-nav__field');
  const menuSearchInput = menuNav.querySelector('.v-nav__input');
  const menuNavSticky = stickyHeader.querySelector('.v-header-sticky__nav');
  const menuNavList = menuNavSticky.querySelector('.v-nav-sticky__list');
  const menuNavItems = menuNavSticky.querySelectorAll('.v-nav-sticky__item');
  const menuNavLinks = menuNavSticky.querySelectorAll('.v-nav-sticky__link');
  const menuStickySearchField = menuNavSticky.querySelector('.v-nav-sticky__field');
  const menuStickySearchInput = menuNavSticky.querySelector('.v-nav-sticky__input');
  const windowWidth = window.innerWidth;
  let scTop = window.pageYOffset;
  let isSticky = false;
  let isMenuOpen = false;
  let isSearchOpen = false;
  let scrollPosY;
  let searchScrollY;
  let updated = 0;

  // SCROLL STICKY
  function openSticky(scrollPosY) {
    scTop = window.pageYOffset;

    if (updated === 0) {
      searchScrollY = scrollPosY;
      updated++;
    }

    if (scTop > 30 && !isSticky) {
      stickyHeader.classList.add('open');
      staticHeader.classList.add('hidden');
      isSticky = true;

      // close search on scroll
      if (isSearchOpen) {
        closeSearch();
      }
    } else if (scTop <= 30 && isSticky) {
      stickyHeader.classList.remove('open');
      staticHeader.classList.remove('hidden');
      isSticky = false;

      if (isSearchOpen) {
        closeSearch();
      }
    }

    // if search is open and user
    // scroll 400px, close search
    if (searchScrollY >= scTop + 400 || searchScrollY <= scTop - 400) {
      closeSearch();
    }
  }
  openSticky();
  window.addEventListener('scroll', openSticky);
  // END SCROLL STICKY

  // MENU
  function triggerMenu() {
    isMenuOpen ? closeMenu() : openMenu();
  }

  function closeMenu(resized) {

    // remove background overlay
    if (menuOverlay.classList.contains('v-header-overlay--active')) {

      // reverse animation
      menuOverlay.classList.add('v-header-overlay--inactive');

      const tl = anime.timeline({
        easing: 'easeInSine',
        duration: 75
      });

      tl.add({
        targets: menuNavLinks,
        translateY: [0, 20],
        opacity: 0,
        delay: anime.stagger(100, {direction: 'reverse'})
      })
      .add({
        targets: menuNavItems,
        opacity: 0,
        delay: anime.stagger(75, {direction: 'reverse'}),
        complete: () => {

          // remove background overlay
          menuOverlay.classList.remove('v-header-overlay--inactive');
          menuOverlay.classList.remove('v-header-overlay--active');

          // return hamburger to initial state
          hamburgerSticky.classList.remove('v-header-sticky__nav-trigger--active');

          // remove active state to list
          menuNavList.classList.remove('v-nav-sticky__list--active');

          // remove 'display: block'
          menuNavSticky.removeAttribute('style');
        }
      }, 0);

    }

    if (!mqMediumLargeNav.matches) {
      anime.set(menuNavItems, {opacity: 1});
      anime.set(menuNavLinks, {translateY: 0, opacity: 1});
    } else if (resized && mqMediumLargeNav.matches) {
      anime.set(menuNavItems, {opacity: 0});
      anime.set(menuNavLinks, {opacity: 0});
    }

    // setTimeout(() => {
    //   // remove background overlay
    //   menuOverlay.classList.remove('v-header-overlay--active');
    //   menuOverlay.classList.remove('v-header-overlay--inactive');

    //   // return hamburger to initial state
    //   hamburgerSticky.classList.remove('v-header-sticky__nav-trigger--active');

    //   // remove active state to list
    //   menuNavList.classList.remove('v-nav-sticky__list--active');

    // }, 700);

    if (scTop <= 30) {
      // hide sticky header
      stickyHeader.classList.remove('open');
      // show static header
      staticHeader.classList.remove('hidden');
    }

    // if browser is resize and horizontal
    // sticky nav should be shown
    if (!mqMediumLargeNav.matches && resized) {
      // show hide <nav>
      // menuNavSticky.style.display = 'block';

      // anime.set(menuNavItems, {opacity: 1});
      // anime.set(menuNavLinks, {translateY: 0, opacity: 1});
    } else {
      // show hide <nav>
      // menuNavSticky.style.display = 'none';

      // anime.set(menuNavItems, {opacity: 0});
      // anime.set(menuNavLinks, {translateY: 20, opacity: 0});
    }

    // toggle menu open state
    isMenuOpen = false;
  }

  function openMenu() {
    // trigger background overlay animation
    menuOverlay.classList.add('v-header-overlay--active');
    // trigger hamburger close state
    hamburgerSticky.classList.add('v-header-sticky__nav-trigger--active');
    // show sticky header
    stickyHeader.classList.add('open');
    // hide static header
    staticHeader.classList.add('hidden');
    // add active state to list
    menuNavList.classList.add('v-nav-sticky__list--active');
    // show hide <nav>
    menuNavSticky.style.display = 'block';

    const tl = anime.timeline({
      easing: 'easeOutSine',
      duration: 200,
    })

    tl.add({
      targets: menuNavItems,
      opacity: 1,
      delay: anime.stagger(100)
    })
    .add({
      targets: menuNavLinks,
      translateY: [20, 0],
      opacity: 1,
      delay: anime.stagger(100)
    }, 0);

    // toggle menu open state
    isMenuOpen = true;
  }
  hamburger.addEventListener('click', triggerMenu);
  hamburgerSticky.addEventListener('click', triggerMenu);
  // END MENU

  // SEARCH
  function triggerSearch() {
    isSearchOpen ? closeSearch() : openSearch();
  }

  function closeSearch() {
    menuStickySearchField.classList.remove('v-nav-sticky__field--active');
    menuSearchField.classList.remove('v-nav__field--active');

    // remove listeners
    staticHeaderSearchBtn.removeEventListener('click', openSearch);
    stickyHeaderSearchBtn.removeEventListener('click', openSearch);
    menuSearchInput.removeEventListener('input', openSearch);
    menuStickySearchInput.removeEventListener('input', openSearch);

    // toggle search open state
    isSearchOpen = false;
  }

  function openSearch() {
    scrollPosY = window.scrollY;
    scTop = window.pageYOffset;

    if (scTop > 30) {
      menuStickySearchField.classList.add('v-nav-sticky__field--active');
      menuStickySearchField.querySelector('input').focus();
    } else if (scTop <= 30) {
      menuSearchField.classList.add('v-nav__field--active');
      menuSearchField.querySelector('input').focus();
    }

    // toggle search open state
    isSearchOpen = true;

    updated = 0;
    openSticky(scrollPosY);
  }

  function searchInput(e) {

    // make sure both input
    // have the same value
    if (e.target == menuSearchInput) {
      menuStickySearchInput.value = e.target.value
    } else {
      menuSearchInput.value = e.target.value
    }

  }
  staticHeaderSearchBtn.addEventListener('click', triggerSearch);
  stickyHeaderSearchBtn.addEventListener('click', triggerSearch);

  menuSearchInput.addEventListener('input', searchInput);
  menuStickySearchInput.addEventListener('input', searchInput);
  // END SEARCH

  window.addEventListener('resize',() => {
    if (windowWidth != window.innerWidth) {
      const resized = true;
      closeMenu(resized);
    }
  });
}

export default header;